import { mockData as meetings } from '@web/lib/demo/data/meetingEvents';
import { MeetType } from '@workalizer/shared';
export var getRecurringMeetings = function (input) {
    return meetings.map(function (event) { return ({
        id: event.meeting.id,
        slugId: event.meeting.slugId,
        workspaceId: event.meeting.workspaceId,
        createdAt: event.meeting.createdAt,
        updatedAt: event.meeting.updatedAt,
        title: event.meeting.title,
        date: event.meeting.date,
        durationSeconds: event.meeting.durationSeconds,
        calendarId: event.meeting.calendarId,
        isExternalParticipantsInvolved: event.meeting.isExternalParticipantsInvolved,
        overrunDurationSeconds: event.meeting.overrunDurationSeconds,
        calendar: null,
        organizerId: event.meeting.organizerId,
        type: MeetType.Recurring
    }); });
};
